import * as React from 'react';
import styles from './index.less';
import FComponentsLib from '@freelog/components-lib';
import { FI18n } from '@freelog/tools-lib';
import { connect } from 'dva';
import { ConnectState, ResourceCreatorPageModelState } from '@/models/connect';
import { Dispatch } from 'redux';
import {
  OnChange_step1_resourceName_Action,
  OnChange_step1_resourceType_Action,
  OnChange_step1_resourceTitle_Action,
  OnClick_step1_createBtn_Action,
  OnVerify_step1_resourceName_Action,
} from '@/models/resourceCreatorPage';
import * as AHooks from 'ahooks';
import FSingleLineInput from '@/components/FSingleLineInput';
import FHotspotTooltip, {
  fSetHotspotTooltipVisible,
} from '@/components/FHotspotTooltip';
import FResourceTypeInput3 from '@/components/FResourceTypeInput3';
import FIcons from '@/components/FIcons';

interface Step1Props {
  dispatch: Dispatch;
  resourceCreatorPage: ResourceCreatorPageModelState;
}

function Step1({ dispatch, resourceCreatorPage }: Step1Props) {
  const { run } = AHooks.useDebounceFn(
    () => {
      dispatch<OnVerify_step1_resourceName_Action>({
        type: 'resourceCreatorPage/onVerify_step1_resourceName',
      });
    },
    {
      wait: 300,
    },
  );

  AHooks.useDebounceEffect(
    () => {
      if (
        !(
          resourceCreatorPage.step1_resourceType === null ||
          resourceCreatorPage.step1_resourceName === '' ||
          resourceCreatorPage.step1_resourceName_errorText !== '' ||
          resourceCreatorPage.step1_resourceName_isVerify ||
          resourceCreatorPage.step1_resourceTitle === '' ||
          resourceCreatorPage.step1_resourceTitle_errorText !== ''
        )
      ) {
        // console.log();
        fSetHotspotTooltipVisible('resourceCreator.step1.createButton', {
          value: true,
          effectiveImmediately: true,
          onlyNullish: true,
        });
      }
    },
    [
      resourceCreatorPage.step1_resourceType,
      resourceCreatorPage.step1_resourceName,
      resourceCreatorPage.step1_resourceName_errorText,
      resourceCreatorPage.step1_resourceName_isVerify,
      resourceCreatorPage.step1_resourceTitle,
      resourceCreatorPage.step1_resourceTitle_errorText,
    ],
    {
      wait: 10,
    },
  );

  return (
    <>
      <div style={{ height: 40 }} />
      <div className={styles.block}>
        {/*<FComponentsLib.FContentText text={'资源类型'} type={'highlight'} />*/}
        <FComponentsLib.FContentText
          text={FI18n.i18nNext.t('rqr_input_resourcetype')}
          type={'highlight'}
        />
        <div style={{ height: 5 }} />
        {/*<FComponentsLib.FContentText text={'选择最贴切描述此资源的类型，其它用户会通过资源类型在资源市场中寻找他们想要的资源。'} type={'additional2'} />*/}
        <FComponentsLib.FContentText
          text={FI18n.i18nNext.t('rqr_input_resourcetype_help')}
          type={'additional2'}
        />
        <div style={{ height: 20 }} />
        <FResourceTypeInput3
          value={resourceCreatorPage.step1_resourceType}
          onChange={(value) => {
            dispatch<OnChange_step1_resourceType_Action>({
              type: 'resourceCreatorPage/onChange_step1_resourceType',
              payload: {
                value: value,
              },
            });
          }}
          showAddNewType={true}
        />

        {resourceCreatorPage.step1_resourceType_errorText !== '' && (
          <>
            <div style={{ height: 5 }} />
            <div style={{ color: '#EE4040', fontSize: 12 }}>
              {resourceCreatorPage.step1_resourceType_errorText}
            </div>
          </>
        )}
      </div>

      <div style={{ height: 5 }} />
      <div className={styles.block}>
        <FComponentsLib.FContentText
          text={FI18n.i18nNext.t('rqr_input_resouce_title')}
          type={'highlight'}
        />
        <div style={{ height: 5 }} />
        <FComponentsLib.FContentText
          text={FI18n.i18nNext.t('rqr_input_resouce_title_help')}
          type={'additional2'}
        />
        <div style={{ height: 20 }} />
        <FSingleLineInput
          value={resourceCreatorPage.step1_resourceTitle}
          lengthLimit={100}
          style={{ width: '100%' }}
          placeholder={FI18n.i18nNext.t('cqr_input_title_hint')}
          onChangeValue={(value) => {
            dispatch<OnChange_step1_resourceTitle_Action>({
              type: 'resourceCreatorPage/onChange_step1_resourceTitle',
              payload: {
                value: value,
              },
            });

            const name: string = value.substring(0, 60);
            // .replace(new RegExp(/(\\|\/|:|\*|\?|"|<|>|\||\s|@|\$|#)+/, 'g'), '_');
            if (
              resourceCreatorPage.step1_resourceTitle ===
                resourceCreatorPage.step1_resourceName &&
              name !== resourceCreatorPage.step1_resourceName
            ) {
              run();
              dispatch<OnChange_step1_resourceName_Action>({
                type: 'resourceCreatorPage/onChange_step1_resourceName',
                payload: {
                  value: name,
                },
              });
            }
          }}
        />

        {resourceCreatorPage.step1_resourceTitle_errorText !== '' && (
          <>
            <div style={{ height: 5 }} />
            <div style={{ color: '#EE4040', fontSize: 12 }}>
              {resourceCreatorPage.step1_resourceTitle_errorText}
            </div>
          </>
        )}
      </div>

      <div style={{ height: 5 }} />

      <div className={styles.block}>
        {/*<FComponentsLib.FContentText text={'资源授权标识'} type={'highlight'} />*/}
        <FComponentsLib.FContentText
          text={FI18n.i18nNext.t('rqr_input_resourceauthid')}
          type={'highlight'}
        />
        <div style={{ height: 5 }} />
        {/*<FComponentsLib.FContentText text={'此资源在整个授权系统中的唯一标识符，一旦创建则不能更改。'} type={'additional2'} />*/}
        <FComponentsLib.FContentText
          text={FI18n.i18nNext.t('rqr_input_resourceauthid_help')}
          type={'additional2'}
        />
        <div style={{ height: 20 }} />
        <div className={styles.resourceName}>
          <FComponentsLib.FContentText
            text={`${resourceCreatorPage.userInfo?.userName} /`}
            style={{
              lineHeight: '38px',
              flexShrink: 0,
              display: 'inline-block',
            }}
          />
          <div style={{ flexShrink: 1 }}>
            <FComponentsLib.FInput.FSingleLine
              value={resourceCreatorPage.step1_resourceName}
              className={styles.FInput}
              style={{ width: 600 }}
              lengthLimit={60}
              // placeholder={FI18n.i18nNext.t('输入资源授权标识')}
              placeholder={FI18n.i18nNext.t('rqr_input_resourceauthid_hint')}
              onChange={(e) => {
                run();
                dispatch<OnChange_step1_resourceName_Action>({
                  type: 'resourceCreatorPage/onChange_step1_resourceName',
                  payload: {
                    value: e.target.value,
                  },
                });
              }}
            />

            {resourceCreatorPage.step1_resourceName_errorText === '' &&
              resourceCreatorPage.step1_resourceName !==
                resourceCreatorPage.step1_resourceName_optimized && (
                <>
                  <div style={{ height: 5 }} />
                  <div>
                    <div
                      style={{
                        color: '#44C28C',
                        fontSize: 12,
                        lineHeight: '18px',
                      }}
                    >
                      你的资源标识将自动转换为{' '}
                      <strong>
                        {resourceCreatorPage.step1_resourceName_optimized}
                      </strong>
                    </div>
                    <div style={{ height: 5 }} />
                    <div
                      style={{
                        color: '#E9A923',
                        fontSize: 12,
                        lineHeight: '18px',
                      }}
                    >
                      {FI18n.i18nNext.t('naming_convention_resource_name')}
                    </div>
                  </div>
                </>
              )}

            {resourceCreatorPage.step1_resourceName_errorText !== '' && (
              <>
                <div style={{ height: 5 }} />
                <div style={{ color: '#EE4040', fontSize: 12 }}>
                  {resourceCreatorPage.step1_resourceName_errorText}
                </div>
              </>
            )}
          </div>
          {resourceCreatorPage.step1_resourceName_isVerify && (
            <FIcons.FLoading style={{ lineHeight: '38px', flexShrink: 0 }} />
          )}

          {!resourceCreatorPage.step1_resourceName_isVerify &&
            resourceCreatorPage.step1_resourceName !== '' &&
            resourceCreatorPage.step1_resourceName_errorText === '' && (
              <FIcons.FCheck style={{ lineHeight: '38px', flexShrink: 0 }} />
            )}
        </div>
      </div>

      <div style={{ height: 30 }} />

      <div className={styles.btn}>
        {/*{FI18n.i18nNext.t('rqr_step1_btn_createnow')}*/}
        <FHotspotTooltip
          id={'resourceCreator.step1.createButton'}
          style={{ left: 32, bottom: -38 }}
          text={FI18n.i18nNext.t('hotpots_rqr_createauthid')}
          onOpenChange={(o) => {
            if (o) {
              fSetHotspotTooltipVisible('resourceCreator.step1.createButton', {
                value: false,
                effectiveImmediately: false,
                onlyNullish: false,
              });
            }
          }}
          // placement={'topRight'}
        >
          <FComponentsLib.FRectBtn
            disabled={
              resourceCreatorPage.step1_resourceType === null ||
              resourceCreatorPage.step1_resourceName === '' ||
              resourceCreatorPage.step1_resourceName_errorText !== '' ||
              resourceCreatorPage.step1_resourceName_isVerify ||
              resourceCreatorPage.step1_resourceTitle === '' ||
              resourceCreatorPage.step1_resourceTitle_errorText !== ''
            }
            type={'primary'}
            onClick={() => {
              dispatch<OnClick_step1_createBtn_Action>({
                type: 'resourceCreatorPage/onClick_step1_createBtn',
              });
            }}
          >
            {FI18n.i18nNext.t('rqr_step1_btn_createnow')}
          </FComponentsLib.FRectBtn>
        </FHotspotTooltip>
      </div>
    </>
  );
}

export default connect(({ resourceCreatorPage }: ConnectState) => ({
  resourceCreatorPage: resourceCreatorPage,
}))(Step1);
